import React, { useState, useEffect, useRef } from 'react'
import ReactFullpage from '@fullpage/react-fullpage'

import { Howl } from 'howler';
import { licenseKey } from '../config.json'
import logEvent from './utils/logEvent'

import Intro from './page/Intro'
import Emotion from './page/Emotion'
import Analysis from './page/Analysis'
import Verse from './page/Verse'
import Product from './page/Product'
import AudioButton from './common/Audio'

export default function MobileBoard() {
    let pageAPI;    
    const [step, setStep] = useState(0)
    const [result, setResult] = useState('')        
    const sound = useRef()

    const saveResult = (selectedOption) => {            
        setResult(selectedOption);        
    }

    const nextStep = () => {
        setStep((prevState) => prevState + 1)
        pageAPI.moveSectionDown();                      
    }

    const prevStep = () => {
        setStep((prevState) => prevState - 1)
        pageAPI.moveSectionUp();
    }

    const toggleSound = () => {
        const volume = sound.current.volume();
        if (volume === 1) {
            sound.current.volume(0.0);
        } else {
            sound.current.volume(1.0);
        }        
    }

    const tapCTA = () => {  
        logEvent(`[BVM] Tap CTA`);        
        window.open(require('../config.json').playStoreLink);
    }

    useEffect(() => {
        sound.current = new Howl({
			src: ["/today_verse_music.mp3"],            
			loop: true
        })        
    }, [])

    useEffect(() => {
        if (step !== 0 && step < 4 && !sound.current.playing()) {
            sound.current.play()
        }
        if (step === 4 && sound.current.playing()) {
            sound.current.stop()        
        }
    }, [step])
    
    useEffect(() => {        
        const stepName = ['Intro', 'Emotion', 'Analysis', 'Verse', 'Product']
        logEvent(`[BVM] PageView - ${stepName[step]}`)         
    },[step])

    return (
        <div>
            <ReactFullpage                    
                licenseKey = {licenseKey}                
                scrollingSpeed = {1500}                                    
                verticalCentered = {false}
                paddingTop = {0}                                 
                touchSensitivity = {1500}
                render={({ fullpageApi }) => {      
                    pageAPI = fullpageApi;                  
                    return (
                        <ReactFullpage.Wrapper>                              
                            <Intro nextStep={nextStep}/>                                                        
                            <Emotion nextStep={nextStep} saveResult={saveResult}/>
                            <Analysis nextStep={nextStep} visible={step === 2}/>
                            <Verse nextStep={nextStep} result={result} visible={step === 3}/>
                            <Product prevStep={prevStep} tapCTA={tapCTA}/>
                        </ReactFullpage.Wrapper>
                    );
                }}
            />       
            { step > 0 && step < 4 && <AudioButton toggleSound={toggleSound}/>}
        </div>        
    )
}